import { createPinia } from "pinia";

export const adminPinia = createPinia();
